import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import APISettings from '@/features/api-settings'

export const Route = createFileRoute('/_authenticated/api-settings')({
  component: APISettings,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Paramètres API`,
      },
    ],
  }),
})
